var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadIcon = function SvgUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    fillRule: "evenodd",
    d: "m7.21 13.71-1.42-1.42L12 6.09l6.21 6.2-1.42 1.42L13 9.91V22h-2V9.91zM4 5v4H2V5c0-1.65 1.35-3 3-3h14c1.65 0 3 1.35 3 3v4h-2V5c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1",
    clipRule: "evenodd"
  })));
};
export { SvgUploadIcon as Icon };
export default __webpack_public_path__ + "static/media/3c2ed67e97f65492192d88831d2d5a5b.svg";